import ThumbVideoZoomable from '~/components/ThumbVideoZoomable'
import ThumbZoomable from '~/components/ThumbZoomable'

type SponsoredBrandsAssetsProps = {
  assets: SponsoredAdsAsset[]
}

export const SponsoredBrandsAssets = ({
  assets
}: SponsoredBrandsAssetsProps) => {
  // Agrupa assets por dimension
  const groupedAssets = assets.reduce(
    (acc: Record<string, SponsoredAdsAsset[]>, asset) => {
      const dimension = asset.dimension || 'default'
      if (!acc[dimension]) {
        acc[dimension] = []
      }
      acc[dimension].push(asset)
      return acc
    },
    {}
  )

  return (
    <>
      {Object.entries(groupedAssets).map(([dimension, dimensionAssets]) => (
        <div key={dimension} className="mt-2">
          <code className="text-sm">{dimension}</code>
          <div
            className="d-flex gap-2 flex-wrap"
            style={{ marginTop: '0.5rem' }}
          >
            {dimensionAssets.map(asset =>
              asset.type === 'video' ? (
                <ThumbVideoZoomable
                  key={asset.url}
                  url={asset.url}
                  title={asset.type}
                  size="tiny"
                />
              ) : (
                <ThumbZoomable
                  key={asset.url}
                  url={asset.url}
                  title={asset.type}
                  size="tiny"
                />
              )
            )}
          </div>
        </div>
      ))}
    </>
  )
}
